// import ModalForm from "./Form";
import { PARENT } from "../../../../../Config/ApiUrl";
import * as actions from "../../../../../Config/ApiUrl";

export const FinanceSchema = {
	components: {},

	data() {
		return {
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "finance-table",
			formId: "finance-table-form",
			rowData: {},
			tableColumns: [
				{
					title: "CLC ID Number",
					type: "text",
					key: "clc_id_number",
				},
				{
					title: "Invoice",
					type: "custom-html",
					key: "invoice_no",
					// modifier: (value) => {
					// 	return value
					// 		? `<a href="" target="_blank">${value}</a>`
					// 		: "";
					// },
					modifier: (value) => {
						return value ? value : "";
					},
				},
				{
					title: "Request Date",
					type: "text",
					key: "request_date",
				},
				{
					title: "Due Date",
					type: "text",
					key: "due_date",
				},
				{
					title: "Status CLC",
					type: "custom-html",
					key: "status",
					modifier: (value) => {
						return value.toLowerCase() === "paid"
							? `<span class="text-success">${value}</span>`
							: `<span class="text-danger">${value}</span>`;
					},
				},
				{
					title: "Status Payment",
					type: "custom-html",
					key: "invoice_payment",
					modifier: (value) => {
						let payment_link = value?.payment_link;
						if (value?.status.toLowerCase() === "pending") {
							return `<a href="${payment_link}" target="_blank" class="btn btn-danger">Pay</a>`;
						} else if (value?.status.toLowerCase() === "paid") {
							return `<span class="text-success">${value?.status}</span>`;
						} else if (value?.status.toLowerCase() === "expired") {
							return `<span class="text-danger">${value?.status}</span>`;
						}
					},
				},
				{
					title: "Grand Total",
					type: "custom-html",
					key: "grand_total",
					modifier: (value) => {
						return this.formattedIDR(value);
					},
				},
			],
			ENDPOINT: PARENT + "/" + this.parentId + "/invoices",
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "FinanceTable",
				url: PARENT + "/" + this.parentId + "/invoices",
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: false,
				columns: [],
				showFilter: false,
				showSearch: true,
				showCount: true,
				showClearFilter: false,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: false,
				orderBy: "desc",
			},
		};
	},
	methods: {
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
	},
};
